module.exports = __webpack_public_path__ + "static/media/betterbusinessact.9de89176.png";